import MainLayout from '../../components/MainLayout/MainLayout'
import CheckVerificationForm from '../../components/Account/CheckVerificationForm'
import styles from '../../styles/Home.module.css'

export default function ForgotPassword() {
  return (
    <div className={styles.container}>
      <MainLayout title="Check Verification">
        <CheckVerificationForm />
      </MainLayout>
    </div>
  )
}
